import { Component } from '@angular/core';
import { AuthService } from "../../services/auth/auth.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../stores/app.state";

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css'],
  standalone: false
})
export class ErrorComponent {

  // @Input()
  // errorMessage: string = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS;
  //
  // errorMessageTitle: string = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS_TITLE;
  //
  constructor(private authService: AuthService, private store: Store<AppState>) {
  }
  //
  // ngOnInit(): void {
  //   this.errorMessage = window.history.state['message'] || this.errorMessage;
  //   this.authService.startSessionPolling();
  //   this.authService.startSessionExpiryWatcher();
  //
  //   // console.log(this.store.selectSignal(selectOauthCodeVerifierValue)())
  //   // console.log(this.store.selectSignal(selectOauthTokenValue)())
  //
  //   switch (this.errorMessage) {
  //     case ClioConstants.NO_STATUS_FOUND:
  //       this.errorMessageTitle = ClioConstants.NO_STATUS_FOUND_TITLE;
  //       break;
  //     case ClioConstants.NO_RECORDS_FOUND:
  //       this.errorMessageTitle = ClioConstants.NO_RECORDS_FOUND_TITLE;
  //       break;
  //     case ClioConstants.CANT_COMPLETE_REQUEST:
  //       this.errorMessageTitle = ClioConstants.CANT_COMPLETE_REQUEST_TITLE;
  //       break;
  //     case ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS:
  //     default:
  //       this.errorMessageTitle = ClioConstants.UNABLE_TO_PROVIDE_DOCUMENTS_TITLE;
  //       break;
  //   }
  //
  // }
  //
  // ngOnDestroy() {
  //   this.authService.stopSessionExpiryWatcher();
  // }
}
